import { c as _c } from "react/compiler-runtime";
import { getAccessLevelDescription } from "@components/access-level/access-level-utils";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { Alert, Dialog, Text } from "@flat-ui";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
/** Confirmation dialog for changing project access level */
export function ChangeAccessLevelConfirmDialog(t0) {
  const $ = _c(15);
  const {
    type,
    accessLevel,
    isOpen,
    isLoading,
    onConfirm,
    onClose
  } = t0;
  const t1 = FaroCoreApiUtils.Project.AccessLevelDisplayNames[accessLevel];
  let t2;
  if ($[0] !== t1) {
    t2 = <Text variant="bodyM">Are you sure you want to change the access level to{" "}<strong>{t1}</strong>?</Text>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== accessLevel || $[3] !== type) {
    t3 = getAccessLevelDescription(type, accessLevel);
    $[2] = accessLevel;
    $[3] = type;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      mt: SPACE_ELEMENTS_OF_MODAL
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Alert variant="info" title={t3} sx={t4} />;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isLoading || $[9] !== isOpen || $[10] !== onClose || $[11] !== onConfirm || $[12] !== t2 || $[13] !== t5) {
    t6 = <Dialog title="Change access level" open={isOpen} onCancel={onClose} confirmText="Change" onConfirm={onConfirm} showSpinner={isLoading} disabled={isLoading}>{t2}{t5}</Dialog>;
    $[8] = isLoading;
    $[9] = isOpen;
    $[10] = onClose;
    $[11] = onConfirm;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}